/*
 * @Description: 
 * @Date: 2019-07-31 16:11:15
 */

export const twoDecimal = (num, divisor = 1, suffix = '') => {
  if (!isNaN(num)) {
    let _num = Number(num) / divisor
    if (/^\d+(\.\d{1})$/.test(_num)) {
      _num = _num + '0'
    } else if (!/\./.test(_num)) {
      _num = _num + '.00'
    }
    return _num + suffix
  } else {
    return '-'
  }
}
export const moneyComplete = (val) => Math.round(Number(val) * 100) // 提交时转成分  注意0.007 * 100 失准 .000000001  .99999999999 四舍五入

export const moneyInt = (val) => {
  return twoDecimal(val, 100)
}